export const config = {
    DEBUG: process.env.NEXT_PUBLIC_STAGE === "local",
    STAGE: process.env.NEXT_PUBLIC_STAGE as "local" | "dev" | "prod" | "pre-prod" | "pov-dev" | "sandbox",
    FRONTEND_URL: process.env.NEXT_PUBLIC_FRONTEND_URL,
    GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
    FACEBOOK_APP_ID: process.env.FACEBOOK_APP_ID,
    NODE_ENV: process.env.NODE_ENV,
};
